"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var apps_shared_1 = require("@l2p/apps-shared");
var useDepositReturnLinks = function () {
    var depositSuccessLink = (0, apps_shared_1.useModalLink)(apps_shared_1.POPUP_CONSTANTS.DEPOSIT_SUCCESS);
    var depositCancelLink = (0, apps_shared_1.useModalLink)(apps_shared_1.POPUP_CONSTANTS.DEPOSIT_CANCEL);
    var depositErrorLink = (0, apps_shared_1.useModalLink)(apps_shared_1.POPUP_CONSTANTS.DEPOSIT_ERROR);
    var generateFullLink = (0, react_1.useCallback)(function (link) {
        if (typeof window !== 'undefined')
            return "".concat(window.location.origin).concat(link);
        return link;
    }, []);
    return (0, react_1.useMemo)(function () {
        return {
            success_url: generateFullLink(depositSuccessLink),
            cancel_url: generateFullLink(depositCancelLink),
            fail_url: generateFullLink(depositErrorLink),
        };
    }, [
        generateFullLink,
        depositSuccessLink,
        depositCancelLink,
        depositErrorLink,
    ]);
};
exports.default = useDepositReturnLinks;
